import { render } from "./Pwa.vue?vue&type=template&id=7af64f52"
import script from "./Pwa.vue?vue&type=script&lang=js"
export * from "./Pwa.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__